export const GENERATE_PQR_REQUEST = "GENERATE_PQR_REQUEST";
export const GENERATE_PQR_SUCCESS = "GENERATE_PQR_SUCCESS";
export const GENERATE_PQR_FAILURE = "GENERATE_PQR_FAILURE";
export const SET_REPORTS_INFO = "SET_REPORTS_INFO";
export const GET_REPORTS_INFO_REQUEST = "GET_REPORTS_INFO_REQUEST";
export const FETCH_PQR_REPORTS_REQUEST = "FETCH_PQR_REPORTS_REQUEST";
export const FETCH_PQR_REPORTS_SUCCESS = "FETCH_PQR_REPORTS_SUCCESS";
export const FETCH_PQR_REPORTS_FAILURE = "FETCH_PQR_REPORTS_FAILURE";
export const PQR_LOADER_START = "PQR_LOADER_START";
export const PQR_LOADER_STOP = "PQR_LOADER_STOP";
export const EXCLUDED_TLOG_SAGA = "EXCLUDED_TLOG_SAGA";
